// French strings of « Mon accès Claude (MCP) » (web/ui/mcpaccess.js): a member's own personal
// keys, made for him by an administrator (registered at module load; see docs/UI-CONTRACT.md §7).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  'mcpa.title': 'Mon accès Claude (MCP)',
  'mcpa.subtitle': 'Votre propre Claude, branché sur le bureau avec vos accès.',
  'mcpa.intro': 'Avec une clé d’accès, votre Claude (claude.ai, l’app Claude ou Claude Code) travaille dans le bureau en votre nom, avec exactement vos accès : voir, lancer, valider ou régler selon vos droits sur les étages et services, et seulement vos connecteurs autorisés. Rien de plus. Chaque appel est inscrit au Journal.',
  'mcpa.rights': 'Vos accès : {grants}. Connecteurs du bureau : {conns}.',
  'mcpa.keys': 'Vos clés',
  'mcpa.empty': 'Aucune clé : votre Claude n’est pas branché sur le bureau.',
  'mcpa.howGet': 'Pour brancher votre Claude, demandez une clé à un administrateur : il vous transmet une adresse secrète, à coller une seule fois dans votre compte claude.ai (étapes ci-dessous).',
  'mcpa.loading': 'Chargement de vos clés…',
  'mcpa.unavailable': 'L’accès de Claude au bureau (MCP) n’est pas activé sur ce serveur.',
  'mcpa.loadError': 'Chargement impossible',
  'mcpa.retry': 'Réessayer',
  'mcpa.created': 'Créée {when} par {name}',
  'mcpa.createdNoName': 'Créée {when}',
  'mcpa.lastUsed': 'dernier usage {when}',
  'mcpa.neverUsed': 'jamais utilisée',
  'mcpa.hint': 'adresse …{hint}',
  'mcpa.revoke': 'Révoquer',
  'mcpa.revokeAria': 'Révoquer la clé « {name} »',
  'mcpa.revokeTitle': 'Révoquer la clé « {name} » ?',
  'mcpa.revokeText': 'Votre Claude ne pourra plus utiliser cette adresse : le connecteur « Maeck Office » qui s’en sert cesse de fonctionner tout de suite. Pour le rebrancher, il faudra demander une nouvelle clé. Cette action est irréversible.',
  'mcpa.revokeOk': 'RÉVOQUER',
  'mcpa.revoked': 'Clé « {name} » révoquée.',
  'mcpa.revokedBadge': 'RÉVOQUÉE',
  'mcpa.full': '{max} clés actives au plus.',
  'mcpa.secretWarn': 'L’adresse de votre clé est un secret : quiconque la connaît agit dans le bureau en votre nom. Ne la collez que dans votre compte claude.ai ; au moindre doute, révoquez-la ici.',
  'mcpa.steps': 'Brancher votre Claude',
});
